import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";

import Paper from "@mui/material/Paper";

import FeatureThumbnail from "../../visComponents/featureThumbnail";
import GroheFeatureNotInVisualizer from "../grohe/groheNavigation/groheFeature/groheFeatureNotInVisualizer";
import {getFeatureSectionIsHidden, hideFeatureSection} from "./lookFunctions2";
import {usePrevious} from "../../../misc/helperHooks";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import {getCurrentLayout} from "../../appLayout";

const LookNotInVisualizerPopper = (props) => {

  const {lookActiveFeature, lookActiveCategory, lookCompatabilityAlert, isMobile, wizardActiveItem, wizardActiveStep,
    isSquareFootageEnabled} = props;
  const [showPopper, setShowPopper] = useState(false);
  const anchorRef = useRef(null);

  const prevActiveStep = usePrevious(wizardActiveStep);

  let checkFeature = lookActiveFeature;
  if (!checkFeature && isMobile && lookActiveCategory) {
    const layout = getCurrentLayout();
    const featureGroup = layout.getFeatureGroupByPartId(lookActiveCategory);
    if (featureGroup) {
      checkFeature = featureGroup.activeNotInVisualizerFeature || featureGroup.activeFeature;
    }
  }

  useEffect(() => {
    setShowPopper(checkFeature && checkFeature.notAvailableInVisualizer);
  }, [checkFeature]);

  useEffect(() => {
    if (isSquareFootageEnabled && showPopper) {
      setShowPopper(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSquareFootageEnabled]);

  useEffect(() => {
    if (wizardActiveItem && showPopper && (prevActiveStep !== wizardActiveStep)) {
      setShowPopper(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep]);

  const showFeaturesOnly = !IS_PRODUCT_JOURNEY
    ? !wizardActiveItem && getFeatureSectionIsHidden(lookActiveFeature)
    : !wizardActiveItem && hideFeatureSection(true, lookActiveCategory, lookActiveFeature, lookCompatabilityAlert);

  return (
    <div className={"look-context look-context--bottom-popper"
      + (showPopper ? " look-context--bottom-popper--opened" : "")
      + (IS_PRODUCT_JOURNEY ? " look-context--bottom-popper--product" : " look-context--bottom-popper--look")
      + ((wizardActiveItem && wizardActiveStep > -1) ? " look-context--bottom-popper--wizard" : "")
      + (!isMobile && (lookActiveCategory || (wizardActiveItem && wizardActiveStep > -1)) ? " look-context--bottom-popper--with-features" : "")
      + (!isMobile && showFeaturesOnly ? " look-context--bottom-popper--featuresOnly" : "")}
         ref={anchorRef}>
      <Paper className="look-context__not-in-vis">
        <div className="lm-feature">
          <div className="lm-feature__thumbnail">
            {checkFeature ? <FeatureThumbnail feature={checkFeature}
                                              lookActiveCategory={lookActiveCategory}
                                              dbFeatureId={checkFeature.dbFeature.id}/> : null}
          </div>
          <div className="lm-feature__content">
            <GroheFeatureNotInVisualizer/>
            <p>This specific product does not display in the visualizer. Please view gallery image examples.</p>
          </div>
        </div>
      </Paper>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookActiveCategory, lookCompatabilityAlert} = store.lookState;
  const {isMobile} = store.serverState;
  const {wizardActiveItem, wizardActiveStep} = store.wizardState;
  const {isSquareFootageEnabled} = store.sqftState;
  const {canvasCount} = store.bathroomVisualizerState;

  return {
    canvasCount,
    lookActiveFeature,
    lookActiveCategory,
    lookCompatabilityAlert,
    isMobile,
    wizardActiveItem,
    wizardActiveStep,
    isSquareFootageEnabled,
  };
};

export default connect(mapStateToProps)(LookNotInVisualizerPopper)
